import Typography from '@mui/material/Typography';
import React, { memo, useEffect } from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Collapse from '@mui/material/Collapse';
import Stack from '@mui/material/Stack';

import { Checkbox, FormControlLabel } from '@mui/material';
import { getField } from 'src/common/helper';

const fontText = {
  fontWeight: '700',
  lineHeight: '12px',
  fontSize: '12px',
};

type ContentProps = {
  doctor: any;
  viewFull: boolean;
  dataContent: any;
  handleOpenDetail: (reservation_id: string) => void;
  onChangeViewFull: () => void;
  fields: any[];
};

const Content: React.FC<ContentProps> = (props) => {
  const isCollapsed = props.viewFull;

  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  return (
    <Box
      sx={{
        width: '100%',
        border: '1px solid #FC6E51',
        borderRadius: '4px',
        bgcolor: getField(props.doctor, 'bgcolor', '#FFF4E5'),
      }}
    >
      <Box
        sx={{
          p: '4px 8px',
          cursor: 'pointer',
          '& *': { cursor: 'pointer' },
        }}
        onClick={() =>
          props.handleOpenDetail(props.dataContent?.reservation_id || '')
        }
      >
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          sx={{
            height: '16px',
            width: '100%',
            display: 'flex',
          }}
        >
          <Stack direction={'row'}>
            <Typography
              sx={{
                ...fontText,
                alignContent: 'center',
                mr: '5px',
              }}
              component='label'
            >
              {getField(props.dataContent, 'start_time', '-')}
            </Typography>
            <Box>
              <Typography
                sx={{
                  ...fontText,
                  alignContent: 'center',
                }}
                component='label'
              >
                {getField(props.dataContent, 'patient_name', '-')}
              </Typography>
            </Box>
          </Stack>

          <Stack direction={'row'} justifyContent={'right'}>
            <Box
              component={'img'}
              src={
                getField(props.dataContent, 'completed', false) === 1
                  ? '/images/icons/ic-ticked-blue.svg'
                  : '/images/icons/ic-warning-red.svg'
              }
              alt='Calendar'
              sx={{ width: '18px', height: '18px' }}
            />
            <Box
              component={'img'}
              src={'/images/icons/ic-pencil-dark.svg'}
              alt='Calendar'
              sx={{ width: '18px', height: '18px', cursor: 'pointer' }}
            />
          </Stack>
        </Stack>

        <Box sx={{ mt: '10px' }}>
          <Box>
            {props.dataContent.category ? (
              <Chip
                label={props.dataContent.category}
                variant='outlined'
                sx={{
                  mr: '4px',
                  mb: '4px',
                  borderRadius: '4px',
                  p: '4px 8px',
                  borderColor: '#23B7E5',
                  color: '#23B7E5 !important',
                  bgcolor: 'primary.light',
                  '& .MuiChip-label': {
                    px: '0px',
                    color: '#23B7E5 !important',
                  },
                  height: '22px',
                }}
              />
            ) : (
              <>
                {Object.keys(props.fields).map((field: string, idx: number) => {
                  return (
                    <Chip
                      key={idx}
                      label={field}
                      variant='outlined'
                      sx={{
                        mr: '4px',
                        mb: '4px',
                        borderRadius: '4px',
                        p: '4px 8px',
                        borderColor: '#23B7E5',
                        color: '#23B7E5 !important',
                        bgcolor: 'primary.light',
                        '& .MuiChip-label': {
                          px: '0px',
                          color: '#23B7E5 !important',
                        },
                        height: '22px',
                      }}
                    />
                  );
                })}
                <Typography fontSize={'10px'}>手術内容を選択してください</Typography>
              </>
            )}
          </Box>
        </Box>
      </Box>
      {props.dataContent.category && (
        <>
          <Box
            sx={{
              p: '4px 8px',
              cursor: 'pointer',
              '& *': { cursor: 'pointer' },
            }}
            onClick={() =>
              props.handleOpenDetail(props.dataContent?.reservation_id || '')
            }
          >
            <Collapse
              in={props.viewFull}
              collapsedSize={'55px'}
              sx={{
                width: '100%',
              }}
            >
              <Stack spacing={'5px'}>
                {props.dataContent?.values &&
                  Array.isArray(props.dataContent?.values) &&
                  props.dataContent.values.map((fv: any, index: number) => {
                    return (
                      <Stack key={index}>
                        {fv.type === 'text' && (
                          <>
                            <Typography
                              sx={{
                                fontWeight: '400',
                                lineHeight: '14px',
                                fontSize: '12px',
                                alignContent: 'center',
                              }}
                              component='label'
                            >
                              {fv.label}
                            </Typography>
                            <Box
                              sx={{
                                width: '100%',
                                border: fv.value
                                  ? '1px solid #BDBDBD'
                                  : '2px solid #ED5565',
                                borderRadius: '4px',
                                bgcolor: '#FFFFFF',
                                p: '8.5px 12px',
                                maxWidth: isCollapsed ? '100%' : '210px',
                                overflow: 'hidden',
                                whiteSpace: isCollapsed ? 'normal' : 'nowrap', // cut text when viewFull = false
                                textOverflow: props.viewFull
                                  ? 'clip'
                                  : 'ellipsis', // show ...
                              }}
                            >
                              <Typography
                                sx={{
                                  fontWeight: '400',
                                  lineHeight: '14px',
                                  fontSize: '12px',
                                  alignContent: 'center',
                                }}
                                component='label'
                              >
                                {fv.value}&nbsp;
                              </Typography>
                            </Box>
                          </>
                        )}
                        {fv.type === 'bool' && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                sx={{
                                  width: '24px',
                                  height: '24px',
                                  color: '#A3AED0',
                                }}
                                checked={fv.value === '1' ? true : false}
                                value={fv.value}
                              />
                            }
                            sx={{
                              ml: '0px',
                              '&.MuiFormControlLabel-root .MuiFormControlLabel-label':
                                {
                                  fontSize: '10px',
                                  fontWeight: '400',
                                },
                              '&.MuiFormControlLabel-root .MuiCheckbox-root .MuiSvgIcon-root':
                                {
                                  fontSize: '16px',
                                },
                            }}
                            label={fv.label}
                          />
                        )}
                      </Stack>
                    );
                  })}
              </Stack>
            </Collapse>
          </Box>
          <Box
            display={'flex'}
            justifyContent={'center'}
            width={'100%'}
            onClick={props.onChangeViewFull}
            sx={{ cursor: 'pointer' }}
          >
            <Box
              component={'img'}
              src={
                props.viewFull
                  ? '/images/icons/ic-arrow-up.svg'
                  : '/images/icons/ic-arrow-down.svg'
              }
              sx={{ width: '24px', height: '24px' }}
            />
          </Box>
        </>
      )}
    </Box>
  );
};

export default memo(Content);
